<template>
    <div class="main-visual-video" :class="{ ready: isReady }">
        <div id="player" />
    </div>
</template>

<script>
export default {
    name: "YoutubeSection",

    mounted() {
        if (window.YT && window.YT.Player) {
            this.createPlayer();
        } else {
            if (!window._youtubeApiLoading) {
                const tag = document.createElement("script");
                tag.src = "https://www.youtube.com/iframe_api";
                document.body.appendChild(tag);
                window._youtubeApiLoading = true;
            }

            window.onYouTubeIframeAPIReady = () => {
                this.createPlayer();
            };
        }
    },

    data() {
        return {
            player: null,
            isReady: false,
            section: { start: 0, end: 13 },
            intervalId: null,
            delay: 100,
        };
    },

    methods: {
        createPlayer() {
            this.player = new window.YT.Player("player", {
                width: "100%",
                height: "auto",
                videoId: "R4DSwK0WfoE",
                playerVars: {
                    autoplay: 1,
                    controls: 0,
                    mute: 1,
                    rel: 0,
                    modestbranding: 1,
                },
                events: {
                    onReady: this.onPlayerReady,
                    onStateChange: this.onPlayerStateChange,
                },
            });
        },

        onPlayerReady() {
            if (this.$vuetify.display?.md) {
                this.delay = 300;
            } else {
                this.delay = 100;
            }

            setTimeout(() => {
                this.isReady = true;
            }, this.delay);

            this.player.seekTo(this.section.start);
            this.player.playVideo();
        },

        onPlayerStateChange(event) {
            if (event.data === window.YT.PlayerState.PLAYING) {
                this.intervalId = setInterval(() => {
                    if (this.player.getCurrentTime() >= this.section.end) {
                        this.player.seekTo(this.section.start);
                    }
                }, 500);
            } else {
                clearInterval(this.intervalId);
            }
        },
    },

    beforeUnmount() {
        clearInterval(this.intervalId);
        if (this.player && this.player.destroy) {
            this.player.destroy();
        }
    },
};
</script>
